const styles = {
    confirmationModalFooter: {
        p: 1,
        display: "flex",
        justifyContent: "left",
        width: "100%",
        gap: "20px",
    },
    requestId: { fontWeight: 700 },
    successModalDesc: { mb: "20px" },
};

export default styles;
